import {
  Button,
  Menu,
  MenuButton,
} from "@chakra-ui/react";
import CartButton from "./CartButton";


const CartNavbar = () => {
  const cart = localStorage.getItem("cart") ? localStorage.getItem("cart") : {};
  return (
    <Menu isLazy={true} placement="bottom-end">
      <MenuButton
        fontSize="14px"
        size="sm"
        p={"0px"}
        colorScheme="rgb(50,174,177)"
        as={Button}
        color="white"
      >
        <CartButton count={cart.length} />
      </MenuButton>
    </Menu>
  );
};

export default CartNavbar;